import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CadastroCliente } from '@/features/cliente/page/cadastro/CadastroCliente';
import { StringToIdpkSchema } from '@/std/schema';

const RouteClienteSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.literal('editar'),
        idpk: StringToIdpkSchema,
    }),
]);

export type RouteClienteParams = z.infer<typeof RouteClienteSchema>;

export const Route = createFileRoute('/a/cliente/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteClienteSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <CadastroCliente {...params} />;
}
